import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#242424",
      d: "M8.21 4.556c-.38.49-.94 1.566-1.293 2.705.5-.172 1.034-.506 1.59-.993C9.674 5.245 9.96 4.365 9.852 3.922q-.056-.229-.249-.27a.5.5 0 0 0-.105-.012c-.423 0-.958.494-1.287.916"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#242424",
      "fill-rule": "evenodd",
      d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m1.486-8.247a.31.31 0 0 1 .368-.171.32.32 0 0 1 .226.342c-.015.142-.378 3.48-1.968 4.66A2.02 2.02 0 0 1 6.887 13a2.3 2.3 0 0 1-.497-.057.3.3 0 0 1-.197-.14.326.326 0 0 1 .094-.444.3.3 0 0 1 .236-.044c.456.102.856.02 1.222-.252.682-.505 1.107-1.553 1.356-2.433-.476.643-.94 1.043-1.377 1.189-.331.11-.647.084-.94-.08-.393-.22-.645-.602-.75-1.135-.084-.432-.07-.958.042-1.564a3 3 0 0 1-.307-.027C4.642 7.846 4.074 6.967 4.05 6.93a.327.327 0 0 1 .092-.444.31.31 0 0 1 .433.094c.004.006.45.679 1.292.8q.174.026.356.018.1-.37.237-.758c.34-.962.835-1.937 1.262-2.485.948-1.214 1.725-1.195 2.015-1.13.363.081.626.351.722.741.244.992-.638 2.196-1.545 2.991-.756.663-1.491 1.074-2.186 1.222-.13.603-.156 1.108-.08 1.5.067.343.21.571.436.698a.53.53 0 0 0 .446.032c.797-.266 1.682-1.862 1.956-2.455",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }